import { Copy } from "lucide-react";
import { useCallback } from "react";
import { formatPhoneNumber } from "@/lib/phone.ts";
import { OkthxLogo } from "@/components/icons/Logo.tsx";
import { Button } from "@/components/ui/button.tsx";
import { confirmationToast } from "@/components/ui/toast.tsx";

/** Wrapper-agnostic contact card content (Settings → Assistant, home save-contact card). */
export const ContactCardBody = ({
  phone,
  email,
  vcfUrl,
}: {
  phone?: string;
  email?: string;
  vcfUrl: string;
}) => {
  const handleCopyEmail = useCallback(async () => {
    if (!email) return;
    await navigator.clipboard.writeText(email);
    confirmationToast("Email copied");
  }, [email]);

  return (
    <>
      {/* Recipient section */}
      <div className="flex flex-row items-start gap-3 pt-4 px-4">
        <OkthxLogo className="size-10 shrink-0" />
        <div className="flex flex-col gap-0.5">
          <span className="font-medium">Okthx Assistant</span>
          {phone && <span className="text-sm">{formatPhoneNumber(phone)}</span>}
          {email && (
            <div className="inline-flex flex-row gap-1">
              <span className="text-sm">{email}</span>
              <Button
                variant="ghost"
                size="action"
                className="-mt-0.5"
                onClick={handleCopyEmail}
                data-statsig-name="home-save-contact-copy-email"
              >
                <Copy className="size-3.5" />
              </Button>
            </div>
          )}
        </div>
      </div>

      {/* Button section */}
      <div className="p-4">
        <a
          href={vcfUrl}
          download="okthx-assistant.vcf"
          data-statsig-name="home-save-contact-download"
        >
          <Button
            variant="primary"
            className="w-full pointer-events-none"
            data-statsig-name="home-save-contact-download"
          >
            Save contact card
          </Button>
        </a>
      </div>
    </>
  );
};
